import * as React from 'react'
import Image from 'next/image'
import { Container } from '../Container'
import { LandingPageButton } from '../LandingPageButton'

export const PricingInfo: React.FC<{
  title: string
  orangeTitle: string
  buttonText: string
  image: any
}> = ({ image, buttonText, title, orangeTitle }) => (
  <section>
    <Container>
      <div className={'grid md:grid-cols-2'}>
        <div className="my-auto text-center md:text-left">
          <h2 className="title">{title}</h2>
          <p className="orange-title">{orangeTitle}</p>
          <p className="description">
            Pricing varies by vehicle make and model. For accurate pricing, contact our brake experts at{' '}
            <a href={'tel:8558005629'}>(855) 800-5629</a> to get the correct pricing for your vehicle.
          </p>
          <div className="flex flex-row justify-center md:justify-start">
            <LandingPageButton buttonText={buttonText} />
          </div>
        </div>
        <div className="text-center">
          <Image layout="responsive" src={image} alt={'Brake Rotor'} className={'mx-auto'} />
        </div>
      </div>
    </Container>
  </section>
)
